
"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";
import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { Skeleton } from "./ui/skeleton";

interface SnafLogoProps {
  className?: string;
}

export const SnafLogo = ({ className }: SnafLogoProps) => {
  const [logoSrc, setLogoSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const settingsRef = doc(db, 'settings', 'app_details');
    
    const unsubscribe = onSnapshot(settingsRef, (docSnap) => {
      setLoading(true);
      let newLogoUrl = "/app-icon.png"; // Default fallback
      let newAppName = "SNA FIN_O2";

      if (docSnap.exists()) {
        const data = docSnap.data();
        if (data.companyLogoUrl) {
          newLogoUrl = data.companyLogoUrl;
        }
        if (data.appName) {
          newAppName = data.appName;
        }
      }
      
      document.title = newAppName;
      setLogoSrc(newLogoUrl);
      setLoading(false);

    }, (error) => {
        console.error("Failed to fetch logo:", error);
        setLogoSrc("/app-icon.png"); // Fallback on error
        setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading || !logoSrc) {
    return <Skeleton className={cn("rounded-full", className)} />;
  }

  return (
    <div
      className={cn(
        "relative flex items-center justify-center",
        className
      )}
    >
      <Image
          src={logoSrc}
          alt="App Logo"
          width={100}
          height={100}
          className="rounded-full object-cover"
          key={logoSrc} // Force re-render when src changes to bust cache
          unoptimized // Helps in bypassing Next.js image optimization cache
        />
    </div>
  );
};
